import { Button, Dropdown, Form, Icon, Input, Menu, Modal, Popover, Tooltip } from "antd";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

import { connect } from "react-redux";
import styles from "./phoneNumbers.scss";
import moment from "moment";
import PhoneInput from "./PhoneInput";
import {
  createPhone,
  deletePhone,
  getPhone,
  getPhones,
  getSMSMessageStatus,
  selectPhone,
  selectPhones,
  selectSMSMessageStatus,
  sendPhoneVerificationCode,
  sendAdminPhoneVerificationEmail,
  verifyPhoneVerificationCode,
  updatePhone,
  clearPhones,
  setPrimaryPhone,
} from "../../routes/Phone/phone.ducks";
import confirmModal from "../../services/confirmModal";
import { rootReducerInterface } from "../../typings/interfaces";
import { getUserProfile, selectLoadedUser, setPhoneVerificationPending } from "../../routes/Auth/auth.ducks";
import { UserRole } from "../../models";

const PhoneNumbers = forwardRef((props, ref) => {
  const { phoneList, isFormPage, userProfile, messageStatus, onChange, draftData, isAdminRoute, adminUserId } = props;
  const isAdmin = userProfile.role === UserRole.admin || userProfile.role === UserRole.superAdmin

  const [isNewRow, setIsNewRow] = useState(false);
  const [codeToVerify, setCodeToVerify] = useState(null); // modal code
  const [isVisible, setIsVisible] = useState(false);
  const [phone, setPhone] = useState(null);
  const [error, setError] = useState("");
  const [isDisabledPrimaryCheckbox, setIsDisabledPrimaryCheckbox] = useState(false);
  const [timeLeft, setTimeLeft] = useState('');
  const [isCooldownOver, setIsCooldownOver] = useState(false);
  const timerRef = useRef(null);
  // for user info - new ad
  const [filteredPhoneList, setFilteredPhoneList] = useState([]);
  const [remainigVerfiedNumbers, setRemainigVerfiedNumbers] = useState([]);
  const isFirstRender = useRef(true);
  const phonesFetchedCount = useRef(0);
  const [isLoading, setIsLoading] = useState(true);
  const [shouldAutoFocus, setShouldAutoFocus] = useState(false);

  useImperativeHandle(ref, () => ({
    addAndFocusNewPhone: () => {
      if (phoneList && phoneList.length < 5) {
        setPhone(null);
        setIsNewRow(true);
        setShouldAutoFocus(true);
      }
    }
  }));

  const OTHER_PHONE_TYPE = "other";
  const MOBILE_PHONE_TYPE = "mobile";
  const userId = isAdminRoute ?
    (
      adminUserId
    ) : (
      isFormPage &&
      draftData &&
      draftData.creatorId &&
      userProfile.userId !== draftData.creatorId
    ) ? draftData.creatorId
      : userProfile.userId;


  const phonesData = isFormPage && props.value ? props.value[props.field] : [];


  useEffect(() => {
    props.getPhones(userId);

    if (phonesData && phonesData.length > 0) {
      phonesFetchedCount.current = 0;

      phonesData.forEach(item => {
        props.getPhone(item, (success) => {
          if (success) {
            setFilteredPhoneList((prev) => [...prev, success])

            // Prevent triggering onChange event on initial load
            phonesFetchedCount.current += 1;

            if (phonesFetchedCount.current === phonesData.length) {
              isFirstRender.current = false;
              setFilteredPhoneList((prev) => prev.sort((a, b) => b.isPrimary - a.isPrimary)); //set first item to be primary num
              setIsLoading(false);
            }
          }
        })

      })
    } else {
      setIsLoading(false);
      isFirstRender.current = false;
    }

    return () => {
      props.clearPhones();
    }
  }, []);

  useEffect(() => {
    if (phoneList && phoneList.length > 0) {
      if (isFormPage) {
        // Remaining
        const remaining = phoneList.filter(all => {
          return !filteredPhoneList.some(choosen => choosen.id === all.id);
        });
        setRemainigVerfiedNumbers(remaining.filter(item => item.isVerified));

        // Primary
        const primary = phoneList.find(item => item.isPrimary);
        if (primary && filteredPhoneList.filter(item => item && item.isPrimary).length === 0 && !phonesData[0]) {
          setFilteredPhoneList([primary])
          onChange({ phoneIds: [primary.id] });
        }

      }
      else {
        setFilteredPhoneList(phoneList);
        // disable primary checbox if its the only primary number
        setIsDisabledPrimaryCheckbox(
          phoneList.filter((phone) => phone.isVerified).length === 1
        );
      }

      if (phoneList.length === 4 && error !== "") {
        setError("");
      }


    }
  }, [
    phoneList,
    isFormPage,
    error
  ]);

  // Apply changes to the form
  useEffect(() => {
    const remaining = phoneList.filter(all => {
      return !filteredPhoneList.some(choosen => choosen.id === all.id);
    });
    setRemainigVerfiedNumbers(remaining.filter(item => item.isVerified));

    if (isFirstRender.current) return; // Prevent triggering onChange event on initial load


    if (isFormPage && !isLoading && filteredPhoneList.length > 0) {
      const givenPhoneIds = filteredPhoneList.map(phone => phone.id);

      if (givenPhoneIds[0] && givenPhoneIds.length > 0) {
        onChange({ phoneIds: givenPhoneIds }); // update the form

        // const updateData = {
        //   ...draftData,
        //   phoneIds: givenPhoneIds, 
        // };

        // localStorage.setItem(LocalStorageKey.savedForm, JSON.stringify(updateData));


      }
    }

  }, [
    phoneList,
    filteredPhoneList,
    isFormPage,
    isLoading,
  ]);


  // Add
  const addPhoneNumber = (phoneNumber, isForeignNumber, entityName, callback) => {
    if (!userProfile) return;
    const data = {
      userId: userId,
      number: phoneNumber.toString(),
      isForeignNumber: isForeignNumber,
      name: entityName, // optional entity name
      //isPrimary: false,
    };

    const handleSuccess = (successPhone) => {
      callback && callback(true);

      setPhone(successPhone);
      props.getPhones(userId);
      setError("");
    }

    // create
    props.createPhone(data, (responseCallback) => {
      if (responseCallback && responseCallback.phone) {
        handleSuccess(responseCallback.phone)
      }
      else if (responseCallback && responseCallback.error) {
        if (isAdmin && responseCallback.error.code === 1056) {
          confirmModal.show({
            title: "Ovaj broj se već koristi na drugom računu.",
            okText: "Dodaj broj",
            iconType: "NaN",
            children: "Želiš li svejedno nastaviti?",
            onOk: () => {
              props.createPhone({ ...data, confirmDuplicate: true }, (modalResponseCallback) => {
                if (modalResponseCallback && modalResponseCallback.phone) {
                  handleSuccess(modalResponseCallback.phone)
                }
              })
            },
          });

        } else {
          callback && callback(false);
          setError("Ovaj broj je već u upotrebi i ne može se verificirati.");
          setPhone(null);
        }

      }
    });

    if (!isFormPage) {
      setIsNewRow(false);
    }

  };

  // Update
  const updatePhoneNumber = (
    id,
    number,
    isForeignNumber,
    entityName,
    isPrimary
  ) => {
    if (!id) return;

    const data = {
      userId: userId,
      number: number,
      isForeignNumber: isForeignNumber,
      name: entityName, // optional entity name
      isPrimary: isPrimary,
    };


    props.updatePhone(id, data, (success) => {
      if (success) {
        // update radio checkbox and if input field is readonly
        props.getPhones(userId);
        setPhone(success);
      }
    });
  };

  // set as primary
  const setPrimaryPhoneNumber = (
    id
  ) => {
    if (!id) return;

    props.setPrimaryPhone(id, (success) => {
      if (success) {
        // update radio checkbox and if input field is readonly
        props.getPhones(userId);
        setPhone(success);
      }
    });
  };


  // Delete
  const removePhoneNumber = (e, number) => {
    e.preventDefault();

    confirmModal.show({
      okText: "Obriši",
      iconType: "NaN",
      children: "Jeste li sigurni da želite obrisati ovaj broj telefona?",
      onOk() {
        if (!number || !number.id) {
          console.warn('Trying to delete a number without ID:', number);
          return;
        }
        // Only delete phone on page "Moji podaci"
        if (!isFormPage) {
          props.deletePhone(number.id, (success) => {
            if (success) {
              props.setPhoneVerificationPending(false);
              props.getUserProfile({}, null, true);
            }
          });

          setFilteredPhoneList((prev) => prev.filter((item) => item.id !== number.id));
        }
        else {
          // here we are just disconnecting it from the single ad
          setFilteredPhoneList((prev) => prev.filter((item) => item.id !== number.id));
          //setRemainigVerfiedNumbers((prev) => [...prev, number]);
          setPhone(null);
          setIsNewRow(false);

        }

      },
    });

  };

  const handleVerifyPhoneVerificationCode = (e, phone) => {
    e.preventDefault();

    if (codeToVerify) {
      props.verifyPhoneVerificationCode(phone.id, codeToVerify, (success) => {
        if (success) {
          setIsVisible(false);
          setIsNewRow(false);

          props.getPhone(phone.id, (success) => {
            if (success) {
              props.getUserProfile();    // update user after he adds first number to be able to post ad

              if (isFormPage) {
                setRemainigVerfiedNumbers((prev) => prev.filter((item) => item.id !== phone.id));
                setFilteredPhoneList((prev) => [...prev, success]);
              }
              else {
                setFilteredPhoneList((prev) =>
                  prev.map(item =>
                    item.id === phone.id ? { ...item, isPrimary: success.isPrimary } : item
                  )
                );

              }

            }
          });

        }

      });
    }

  };

  const verifyPhoneNumber = (type, phoneItem) => {
    // 1.verify phone number with code
    if (isAdminRoute) {
      props.verifyPhoneVerificationCode(phoneItem.id, null, (success) => {
        if (success) {

          props.getPhone(phoneItem.id, (success) => {
            if (success) {
              props.getUserProfile();    // update user after he adds first number to be able to post ad

              setFilteredPhoneList((prev) =>
                prev.map(item =>
                  item.id === phoneItem.id ? { ...item, isPrimary: success.isPrimary } : item
                )
              );
            }
          });

        }

      })
    }
    else {
      if (type === MOBILE_PHONE_TYPE) {
        setIsVisible(true);
        setPhone(phoneItem);


        // first send code 
        // then fetch user profile phoneVerificationCodeTime to set the timer
        props.sendPhoneVerificationCode(phoneItem.id, (success) => {
          if (success) {
            props.getUserProfile(undefined, (success) => {
              const now = moment().utc();
              const cooldownEnd = success.phoneVerificationCodeTime
                ? moment.utc(success.phoneVerificationCodeTime)
                : moment().utc().add(2, 'minutes');

              if (now.isBefore(cooldownEnd)) {
                const duration = moment.duration(cooldownEnd.diff(now));
                const minutes = Math.floor(duration.asMinutes());
                const seconds = duration.seconds();

                setTimeLeft(`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);

                setIsCooldownOver(false);

                // clean the interval
                if (timerRef.current) {
                  clearInterval(timerRef.current);
                }

                // start new interval
                timerRef.current = setInterval(() => {
                  const now = moment.utc();
                  if (now.isBefore(cooldownEnd)) {
                    const duration = moment.duration(cooldownEnd.diff(now));
                    const minutes = Math.floor(duration.asMinutes());
                    const seconds = duration.seconds();
                    setTimeLeft(`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);
                  } else {
                    setIsCooldownOver(true);
                    setTimeLeft('');
                    clearInterval(timerRef.current);
                  }
                }, 1000);
              }
            })
          }
        });

      } else if (type === OTHER_PHONE_TYPE) {
        // 2.send email to admin
        confirmModal.show({
          title: "Verifikacija broja telefona",
          okText: "U redu",
          iconType: "NaN",
          cancelButtonProps: { style: { display: "none" } }, // hide cancel button
          children: <p>{"Vaš broj je poslan na provjeru i bit će odobren najkasnije u roku od 48 sati. Očekujte naš poziv za potvrdu broja."}</p>,
        });

        props.sendAdminPhoneVerificationEmail(phoneItem.id, () => {
          props.setPhoneVerificationPending(true);
          props.getUserProfile({}, null, true);
        });
      }
    }
  };

  // Close modal and reset
  const handleCancel = () => {
    setIsVisible(false);
    // setPhone(null);
    setCodeToVerify(null);
  };

  const handleAddNewRow = () => {
    if (phoneList && phoneList.length < 5) {
      if (!isFormPage) {
        setPhone(null);
        setIsNewRow(true);
      }
      else {
        if (!phone || !filteredPhoneList.find(item => !item.isVerified)) {
          setPhone(null);
          setIsNewRow(true);
        }
        else {
          // dont set new row if user didnt verify previous number on form page
          setError("Morate prvo verificirati broj");
        }
      }
    } else {
      setError("Možete dodati najviše 5 telefonskih brojeva.");
    }
  };

  const handleAddNewVerifiedRow = ({ key }) => {
    if (key === 'add') {
      handleAddNewRow();
    }
    else {
      const foundItem = remainigVerfiedNumbers.find(item => item.id === key);

      setFilteredPhoneList((prev) => [...prev, foundItem]);
      setRemainigVerfiedNumbers((prev) => prev.filter(item => item.id !== key));
      setPhone(null);
    }
  };

  const menu = (
    <Menu onClick={handleAddNewVerifiedRow} className={styles.menu}>
      {remainigVerfiedNumbers.length > 0 &&
        <p className={styles.text}>{"Odaberi broj:"}</p>}

      {remainigVerfiedNumbers.length > 0 && (
        remainigVerfiedNumbers.map(item =>
          <Menu.Item key={item.id} className={styles.menuItem}>{item.number}</Menu.Item>
        )
      )}


      <Menu.Item
        className={styles.menuItem}
        key="add"
        disabled={isNewRow}
      >
        {"Dodaj novi broj"}
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    if (!isVisible) {
      setCodeToVerify(null)
    }
  }, [isVisible]);

  return (
    <Form.Item className={`${styles.container} ${isFormPage ? styles.userInfo : ''}`}>
      {!isFormPage && (
        <React.Fragment>
          <h6 className={styles.subHeading}>{"Kontakt telefon"}
            <Popover
              className={styles.infoPopover}
              trigger="click"
              content={
                <p>
                  <b>Zašto verifikacija broja telefona?</b><br />
                  Verifikacijom potvrđujemo da ste stvarna osoba ili tvrtka i štitimo vas od neželjenih oglasa.<br /><br />

                  <ul>
                    <li><b>Zaštita od prijevara:</b> sprječavamo lažne i spam oglase.</li>
                    <li><b>Brža komunikacija:</b> kupci i prodavači odmah mogu sigurno komunicirati.</li>
                    <li><b>Pouzdanost podataka:</b> točan broj omogućuje kvalitetniju podršku i pravovremene obavijesti.</li>
                  </ul>

                  Broj uvijek možete sakriti iz svojih oglasa u bilo kojem trenutku na stranici postavki:<br />
                  <a
                    href="../oglasi/postavke"
                    target="_blank"
                    style={{ color: '#f94144' }}
                  >
                    https://www.index.hr/oglasi/postavke
                  </a>
                </p>
              }
            >

              <Icon
                className={styles.infoIcon}
                type="info-circle-o"
              />
            </Popover>
          </h6>

        </React.Fragment>
      )}

      {filteredPhoneList &&
        filteredPhoneList.length > 0 &&
        filteredPhoneList.map((item, i) => (
          <PhoneInput
            phone={item}
            legalEntity={userProfile.legalEntity}
            handleAddPhoneNumber={addPhoneNumber}
            handleUpdatePhoneNumber={updatePhoneNumber}
            handleSetPrimaryPhoneNumber={setPrimaryPhoneNumber}
            handleRemovePhoneNumber={removePhoneNumber}
            verifyPhoneNumber={verifyPhoneNumber}
            isDisabledCheckbox={isDisabledPrimaryCheckbox}
            isFormPage={isFormPage}
            isOnlyItem={filteredPhoneList.length === 1}
            isAdminRoute={isAdminRoute}
            error={error}
            key={i}
          />
        ))}

      {/* Additional row */}
      {isNewRow && (
        <PhoneInput
          phone={(isFormPage && phone && !phone.isVerified) ? phone : null}
          // phone={null}
          legalEntity={userProfile.legalEntity}
          handleAddPhoneNumber={addPhoneNumber}
          handleUpdatePhoneNumber={updatePhoneNumber}
          handleSetPrimaryPhoneNumber={setPrimaryPhoneNumber}
          handleRemovePhoneNumber={removePhoneNumber}
          verifyPhoneNumber={verifyPhoneNumber}
          isDisabledCheckbox={true}
          isFormPage={isFormPage}
          isOnlyItem={false}
          isAdminRoute={isAdminRoute}
          error={error}
          autoFocus={shouldAutoFocus}
        />
      )}

      <div className={styles.addNumberContainer}>
        {!isFormPage && (
          <Button
            className={styles.addNumber}
            key="add-number"
            type="default"
            size="default"
            onClick={handleAddNewRow}
          >
            {"+ Dodaj broj"}
          </Button>
        )}

        {isFormPage && (
          <Dropdown
            overlay={menu}
            placement="bottomLeft"
            trigger={['click']}>
            <Button
              onClick={e => e.preventDefault()}
              className={styles.addNumber}
              key="add-number"
              type="default"
              size="default">
              {"+ Dodaj broj"}

            </Button>
          </Dropdown>

        )}

        <p className={styles.error}>{error}</p>


      </div>

      {phone && (
        /* Modal for verification code*/
        <Modal
          visible={isVisible}
          onCancel={handleCancel}
          title={"Verifikacija broja telefona"}
          className={styles.codeModalContainer}
        >
          <div>
            <p className={styles.textCode}>
              {"Poslali smo kod na "}
              <span>{phone.number}</span>.
            </p>
            <p className={styles.modalText}>
              {"Unesite ga ispod kako biste verificirali broj:"}
            </p>
          </div>
          <Input.Group className={styles.inputContainer}>
            <Input
              className={styles.input}
              onChange={(e) => setCodeToVerify(e.target.value)}
              value={codeToVerify}
              size="small"
              type="numeric"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="one-time-code" //only works on ios what for andoid ?
              autoFocus
            />
            <button
              className={styles.button}
              onClick={(e) => handleVerifyPhoneVerificationCode(e, phone)}
            >
              {"Potvrdi kod"}
            </button>
          </Input.Group>
          {!isCooldownOver && <span className={styles.timeoutTxt}>
            {"Kod možeš ponovo poslati za: "}{timeLeft}
          </span>
          }
          {isCooldownOver &&
            <span className={`${styles.timeoutTxt} ${styles.timeoutTextAction}`}
              onClick={() => verifyPhoneNumber(MOBILE_PHONE_TYPE, phone)}>
              {"Pošalji kod ponovo"}
            </span>
          }

        </Modal>
      )}
    </Form.Item>
  );
});

PhoneNumbers.defaultProps = {
  phoneList: [],
  phone: null,
  messageStatus: null,
};

export default connect(
  (state: rootReducerInterface, props) => ({
    // selectors
    phoneList: selectPhones(state),
    phone: selectPhone(state),
    messageStatus: selectSMSMessageStatus(state),
    userProfile: selectLoadedUser(state),
  }),
  {
    getPhones,
    clearPhones,
    getPhone,
    createPhone,
    updatePhone,
    deletePhone,
    setPrimaryPhone,
    sendPhoneVerificationCode,
    sendAdminPhoneVerificationEmail,
    verifyPhoneVerificationCode,
    getSMSMessageStatus,
    getUserProfile,
    setPhoneVerificationPending,
  },
  null,
  { forwardRef: true }
)(PhoneNumbers);



// WEBPACK FOOTER //
// ./src/components/PhoneNumbers/index.tsx